import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { SurveyLanguage, SurveyLocalizations } from '../models/survey-language.interface';
import { TranslationEntry } from '../models/translation-entry.interface';
import { Translation } from '../models/translation.interface';

@Injectable({ providedIn: 'root' })
export class TranslationsService {
  private http = inject(HttpClient);

  constructor(@Inject('environment') private environment: EnvironmentConfig) {}

  getByResearchMethodAndCode(researchMethodId: string, code: string): Observable<Translation> {
    return this.http.get<Translation>(`${this.environment.surveyEndPoint}translations/${researchMethodId}/${code}`);
  }

  create(researchMethodId: string, code: string, entries: TranslationEntry[]): Observable<Translation> {
    return this.http.post<Translation>(`${this.environment.surveyEndPoint}translations`, {
      researchMethodId,
      code,
      entries
    });
  }

  update(researchMethodId: string, code: string, entries: TranslationEntry[]): Observable<Translation> {
    return this.http.put<Translation>(`${this.environment.surveyEndPoint}translations/${researchMethodId}/${code}`, {
      entries
    });
  }

  delete(researchMethodId: string, code: string): Observable<void> {
    return this.http.delete<void>(`${this.environment.surveyEndPoint}translations/${researchMethodId}/${code}`);
  }

  getSystemTranslations(languageCode: string): Observable<SurveyLocalizations> {
    return this.http.get<SurveyLanguage>(`${this.environment.surveyEndPoint}languages/system/${languageCode}`).pipe(
      map((response) => ({
        system: JSON.parse(response.localizations.system),
        error: JSON.parse(response.localizations.error)
      }))
    );
  }
}
